import {
  Box,
  FormLabel,
  Grid,
  Stack,
  Typography,
  } from "@mui/material"
import { getEmploymentContract } from "../../api"
import React from "react"
import { useState, useEffect } from "react"
import { useSnackbar } from "notistack"

const ContractDetails = ({user}) => {
    const [employmentContract, setEmploymentContract] = useState({})
    const { enqueueSnackbar } = useSnackbar()

    const fetchEmploymentContract = () => {
      getEmploymentContract(user?.sub)
        .then((res) => {
          setEmploymentContract(res.data)
        })
        .catch((err) => enqueueSnackbar(err.data, { variant: "error" }))
    }

    useEffect(() => {
      fetchEmploymentContract()
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <Box>
            <Typography variant="h6" sx={{ letterSpacing: 2 }} color="primary">
              EMPLOYMENT DETAILS
            </Typography>
            <Stack spacing={1} sx={{ mt: 2 }} alignItems="flex-start">
              <Grid container spacing={1} mb={2}>
                <Grid item xs={12} sm={4}>
                  <Stack
                    style={{
                      textOverflow: "ellipsis",
                      overflow: "hidden",
                      whiteSpace: "nowrap",
                    }}
                  >
                    <FormLabel>Designation</FormLabel>
                    {employmentContract?.designation}
                  </Stack>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Stack
                    style={{
                      textOverflow: "ellipsis",
                      overflow: "hidden",
                      whiteSpace: "nowrap",
                    }}
                  >
                    <FormLabel>Institute</FormLabel>
                    {employmentContract?.institution}
                  </Stack>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Stack
                    style={{
                      textOverflow: "ellipsis",
                      overflow: "hidden",
                      whiteSpace: "nowrap",
                    }}
                  >
                    <FormLabel>Contract Status</FormLabel>
                    {employmentContract?.contractStatus || "N/A"}
                  </Stack>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Stack
                    style={{
                      textOverflow: "ellipsis",
                      overflow: "hidden",
                      whiteSpace: "nowrap",
                    }}
                  >
                    <FormLabel>Joining Date</FormLabel>
                    {employmentContract?.contractStartDate ? employmentContract?.contractStartDate.split("T")[0] : "N/A"}
                  </Stack>
                </Grid>

                <Grid item xs={12} sm={4}>
                  <Stack
                    style={{
                      textOverflow: "ellipsis",
                      overflow: "hidden",
                      whiteSpace: "nowrap",
                    }}
                  >
                    <FormLabel>Last Working Date</FormLabel>
                    {employmentContract?.contractEndDate ? employmentContract?.contractEndDate.split("T")[0] : "N/A"}
                  </Stack>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Stack
                    style={{
                      textOverflow: "ellipsis",
                      overflow: "hidden",
                      whiteSpace: "nowrap",
                    }}
                  >
                    <FormLabel>Aadhar No.</FormLabel>
                    {employmentContract?.aadhar || "N/A"}
                  </Stack>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Stack
                    style={{
                      textOverflow: "ellipsis",
                      overflow: "hidden",
                      whiteSpace: "nowrap",
                    }}
                  >
                    <FormLabel>PAN</FormLabel>
                    {employmentContract?.pan || "N/A"}
                  </Stack>
                </Grid>
              </Grid>
            </Stack>
          </Box>
    )
}

export default ContractDetails